module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


// WEBPACK FOOTER //
// ./~/babel-runtime/~/core-js/library/modules/_fails.js